import type { ComponentProps, JSX } from "solid-js";
import type { IconName } from "../icon/Icon";
import { Icon } from "../icon/Icon";

type OptionButtonProps = {
  icon: IconName;
  title: string;
  hasError: boolean;
  disabled: boolean;
  onClick?: () => void;
  htmlProps?: ComponentProps<"button">;
};

const OptionButton = (props: OptionButtonProps): JSX.Element => (
  <button
    type="button"
    title={props.title}
    disabled={props.disabled}
    onClick={() => props.onClick?.()}
    class="group flex min-h-9.5 w-9.5 items-center justify-center rounded-sm border border-button-border-secondary bg-button-bg-secondary-default p-2.5 disabled:cursor-not-allowed disabled:border-0 disabled:bg-button-bg-secondary-disabled"
    classList={{
      "border-error": props.hasError,
      "hover:bg-button-bg-secondary-hover focus-visible:outline-default active:bg-button-bg-secondary-pressed":
        !props.disabled,
      "border-default hover:border-button-border-secondary-hover active:border-button-border-secondary-pressed":
        !props.hasError && !props.disabled,
    }}
    {...props.htmlProps}
  >
    <Icon
      name={props.icon}
      type="solid"
      size="md"
      class="icon-button-icon-secondary-default group-disabled:icon-button-icon-secondary-disabled"
    />
  </button>
);

export default OptionButton;
